import type { MarketApp as MarketAppType } from '@wix/ambassador-devcenter-market-apps-v1-market-app/types';
import { MarketApp } from './market-app';

export class MarketApps {
  constructor(private readonly marketApps: MarketAppType[]) {}

  findByAppId(appId: string) {
    return new MarketApp(
      this.marketApps.find((app) => app.appId === appId),
    ).toJSON();
  }
}
